import {
	Radio,
	RadioGroup,
	SelectContent,
	SelectItem,
	SelectLabel,
	SelectRoot,
	SelectTrigger,
	SelectValueText,
} from '../../../components'
import { Select as ChakraSelect, Checkbox, SelectRootProps, useBreakpointValue } from '@chakra-ui/react'

import React from 'react'

export type SelectInputProps = SelectRootProps & {
	label: React.ReactNode
	placeholder?: string
	clearable?: boolean
	orientation?: 'horizontal' | 'vertical'
	ref?: React.Ref<any>
}

export const SelectInput = ({
	label,
	placeholder,
	clearable,
	orientation = 'vertical',
	multiple,
	ref,
	...props
}: SelectInputProps) => {
	const orientationProps = orientation === 'horizontal' ? { flexDir: 'row', alignItems: 'center', gap: 4 } : {}


	const positioning = useBreakpointValue({
		base: { placement: 'right', fitViewport: true },
		md: { placement: 'bottom-start', fitViewport: true },
	} as const)

	return (
		<SelectRoot positioning={positioning} multiple={multiple} {...props} {...orientationProps}>
			{label && <SelectLabel textStyle="fieldLabel">{label}</SelectLabel>}
			<SelectTrigger clearable={clearable} flex={1} bg='white'>
				<SelectValueText placeholder={placeholder}  />
			</SelectTrigger>
			<SelectContent minW="150px" portalRef={ref as never}>
				{props.collection.items.map((item) => (
					<SelectItem key={item.value} item={item}>
						<ChakraSelect.Context>
							{(select) => {
								const items = select.selectedItems
								const isSelected = items.find((selectedItem) => (selectedItem as any).value === item.value) as
									| boolean
									| undefined
								return multiple ? (
									<Checkbox.Root gap={4} checked={isSelected ?? false} >
										<Checkbox.HiddenInput />
										<Checkbox.Control />
										<Checkbox.Label>{item.label}</Checkbox.Label>
									</Checkbox.Root>
								) : (
									<RadioGroup key={item.value} value={(select.selectedItems[0] as any)?.value} >
										<Radio value={item.value} gap={4}>
											{item.label}
										</Radio>
									</RadioGroup>
								)
							}}
						</ChakraSelect.Context>
					</SelectItem>
				))}
			</SelectContent>
		</SelectRoot>
	)
}
